import { Avatar, Card, Col, Pagination, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { LuMapPin } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../../components/FormElements/Button";
import Modal from "../../../../components/Modal";
import AddQuote from "../../Quotation/AddQuote";
import { useDispatch, useSelector } from "react-redux";
import { setAppLoading, setError } from "../../../../store/common/generalSlice";
import useJobApi from "../../../../config/hooks/api/booking/job/useJobApi";
import { fetchProfileData } from "../../../../store/common/settingSlice";
import { getEllipsedString, getServicesList } from "../../../../config/utils";
import ChatModal from "../../../Common/Chats/ChatModal";

const JobListings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { getJobListing } = useJobApi();

  const [jobs, setJobs] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [qoutesServices, setQuotesServices] = useState(null);
  const [spProfileData, setSpProfileData] = useState(null);
  const [displayQuotesServices, setDisplayQuotesServices] = useState(null);

  const getOpenJobsListing = async (reset = false) => {
    try {
      dispatch(setAppLoading(true));

      const response = await getJobListing(pageSize, reset ? 0 : offset);
      if (response) {
        setJobs(response?.data?.jobs?.rows);
        setTotalItems(response?.data?.jobs?.count);
        setOffset(offset + pageSize);

        dispatch(setAppLoading(false));
      }
    } catch (error) {
      console.log(error);
      dispatch(setAppLoading(false));
    }
  };

  const { profileData } = useSelector((state) => state?.setting);

  // case to get profile of a sp to stop submitting a quote in case not verified by admin.
  useEffect(() => {
    dispatch(fetchProfileData());
  }, []);

  useEffect(() => {
    if (profileData) {
      setSpProfileData(profileData?.userDetail);
    }
  }, [profileData]);

  const closeModal = () => {
    setModal(false);
  };

  const handleSubmitQuoteForm = async (
    bookingId,
    requestedServices,
    displayServices
  ) => {
    // shows document is varified
    if (spProfileData?.status && spProfileData?.status == 1) {
      try {
        if (requestedServices && requestedServices.length) {
          setQuotesServices(requestedServices);
          setDisplayQuotesServices(displayServices);
        }
        setModal(true);
        setSelectedJobId(bookingId);
      } catch (error) {
        return false;
      }
    } else {
      dispatch(setError("Business verification required."));
    }
  };

  const handleAddQuoteSuccess = () => {
    setModal(false);
    getOpenJobsListing(true);
  };

  const onShowSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    setOffset((page - 1) * pageSize);
  };

  useEffect(() => {
    getOpenJobsListing();
  }, [currentPage, pageSize]);

  return (
    <Row>
      <Col span={24}>
        {jobs && jobs.length
          ? jobs.map((job) => {
              let servicesLength = job?.services?.length || 0;
              return (
                <Card
                  key={"job" + job?.id}
                  bordered={false}
                  className="mb-4 rounded-md cursor-pointer"
                >
                  <div className="flex flex-col">
                    <div
                      className="flex sm:flex-row justify-between flex-col w-full sm:mb-0 mb-4"
                      onClick={() => navigate(`/job/${job?.id}`)}
                    >
                      <div className="flex">
                        <div className="flex sm:flex-row flex-col justify-center items-center mb-2">
                          <span className="border-2 p-1 mb-2 border-primary rounded-full">
                            <Avatar
                              src={job?.serviceUser?.imageThumbUrl}
                              className="img-fluid w-[80px] h-[80px]"
                            />
                          </span>
                        </div>
                        <div className="sm:ml-2">
                          <div className="flex justify-center sm:justify-start">
                            <h3 className="heading-3 font-bold mb-2">
                              {job?.serviceUser?.fullName}
                            </h3>
                          </div>
                          {/* previous work */}
                          {/* <div className='flex justify-center sm:justify-start'>
                                            {
                                                job?.services &&
                                                job?.services.length ? (
                                                    <React.Fragment>
                                                        {job?.services.slice(0, 3).map((service, index) => (
                                                            <span key={service?.id}>
                                                                <p className='text-gray-500 font-semibold text-xs mb-3' >
                                                                    {service?.name}
                                                                    
                                                                    {index < job?.services.slice(0,3).length - 1 && 
                                                                    (<span className='mx-1'>|</span>) }
                                                                    {index == 2 && job?.services.length > 3 ? 
                                                                    (<span className='mr-1'>...</span>) : '' }
                                                                </p>
                                                            </span>
                                                        ))}
                                                        {job?.services?.length > 3 ? (
                                                            <Tooltip title={getServicesList(job?.services)}>
                                                                <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                            </Tooltip>
                                                        ) : ''}
                                                    </React.Fragment>
                                                ) : (
                                                <small className='text-xs'>Services not available</small>
                                                )
                                            }
                                            </div> */}

                          {/* updated work */}
                          <div className="flex justify-center sm:justify-start">
                            {job?.services && servicesLength > 0 ? (
                              <React.Fragment>
                                {job?.services?.slice(0, 3)?.map((service) => {
                                  return (
                                    <span
                                      className="flex gap-1 items-center"
                                      key={service?.id}
                                    >
                                      <p className="text-gray-500 font-semibold text-xs mb-3">
                                        {service?.name + ","}
                                      </p>
                                    </span>
                                  );
                                })}
                                {servicesLength > 4 && <span>...</span>}
                                {servicesLength > 4 && (
                                  <Tooltip
                                    title={getServicesList(
                                      job?.services,
                                      false
                                    )}
                                  >
                                    <p className="text-xs ml-2 cursor-pointer">
                                      show all
                                    </p>
                                  </Tooltip>
                                )}
                              </React.Fragment>
                            ) : (
                              <small className="text-xs">
                                Services not available
                              </small>
                            )}
                          </div>

                          <div className="flex sm:justify-start justify-center">
                            <p className="text-xs">{job?.details}</p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <small className="text-[#FF1D6A] font-semibold text-end">
                          (
                          {job?.distance &&
                            job?.distance.toFixed(2) + " Miles Away"}
                          )
                        </small>
                      </div>
                    </div>

                    <hr className="border-dashed border-1 border-gray-200 sm:mb-2 mb-4" />

                    <div className="flex sm:flex-row flex-col sm:justify-between">
                      <div className="flex sm:flex-row flex-col justify-start">
                        <div className="flex sm:mr-2 mr-2 items-center sm:mb-0 mb-2">
                          <div className="w-[20px]">
                            <LuMapPin className="text-2xl text-white bg-primary p-[3px] rounded-full mr-2" />
                          </div>
                          <small className="inline-block ml-3 text-xs font-md">
                            {job?.address &&
                            job?.address.length &&
                            job?.address.length > 50 ? (
                              <Tooltip title={job?.address}>
                                <span className="text-xs cursor-pointer">
                                  {getEllipsedString(job?.address, 50)}
                                </span>
                              </Tooltip>
                            ) : (
                              job?.address
                            )}
                          </small>
                        </div>
                        {/* <div className='flex sm:mx-2 items-center sm:mb-0 mb-2'>
                                                <Link to={`tel:${job?.serviceUser?.phoneNo}`} className='flex h-full items-center'>
                                                    <FaPhoneAlt className='text-2xl text-white p-[4px] rounded-full mr-2 bg-[#3879f0]' />
                                                    <small className='text-xs font-md'>{job?.serviceUser?.phoneNo}</small>
                                                </Link>
                                            </div> */}
                      </div>
                      <div className="flex sm:flex-row flex-col justify-center ml-2">
                        <div className="sm:mr-2 mr-0 sm:mb-0 mb-2 pt-[5px] px-2 bg-[#feedbf] rounded-md">
                          <ChatModal
                            selectedChatMemberData={job?.serviceUser}
                          />
                        </div>
                        <div className="sm:w-fit w-full">
                          <Button.Basic
                            type="primary"
                            size={"medium"}
                            text={"Submit a Quote"}
                            onClick={() =>
                              handleSubmitQuoteForm(
                                job?.id,
                                job?.selectedCategories,
                                job?.services
                              )
                            }
                            disabled={false}
                            className="bg-primary h-[40px] w-full"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              );
            })
          : "No jobs available"}
        <Modal.Basic
          open={modal}
          onCancel={closeModal}
          width={400}
          maskClosable={false}
        >
          <AddQuote
            displayServices={displayQuotesServices}
            qoutesServices={qoutesServices}
            bookingId={selectedJobId}
            onSuccess={handleAddQuoteSuccess}
          />
        </Modal.Basic>
      </Col>

      {totalItems ? (
        <Col span={24}>
          <div className="px-2 py-4 bg-white rounded-md">
            <Pagination
              defaultPageSize={5}
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              current={currentPage}
              total={totalItems}
              pageSize={pageSize}
              pageSizeOptions={[5, 10, 20, 50]}
              onChange={onPageChange}
            />
          </div>
        </Col>
      ) : null}
    </Row>
  );
};

export default JobListings;
